export const promoBlockColorMap = {
    blueberry50: 'blueberry',
    blueberry500: 'blueberry',
    cherry50: 'cherry',
    cherry500: 'cherry',
    neutral50: 'neutral',
    neutral700: 'neutral',
};
